import { useState } from "react";
import { Button, Modal, Spinner } from "flowbite-react";
import { API_BASE_URL } from "../../../config";

const CloverPayment = ({ cupon, merchantId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  const usuario_id = localStorage.getItem("usuario_id");
  const token = localStorage.getItem("auth_token");
  const cliente_id = localStorage.getItem("cliente_id");

const handleCheckout = async () => {
  setLoading(true);
  setError("");

  try {
    // 🚀 Asegurar que el usuario_id y token existen en el momento de ejecutar la función
    const usuario_id = localStorage.getItem("usuario_id") || "";
    const token = localStorage.getItem("auth_token") || "";
    const cliente_id = localStorage.getItem("cliente_id") || "";

    if (!merchantId) throw new Error("❌ No se encontró un Merchant ID para este cliente.");
    if (!cliente_id) throw new Error("❌ No se encontró un cliente_id válido.");

    const response = await fetch(`${API_BASE_URL}/checkout-clover`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        merchant_id: merchantId,
        usuario_id: usuario_id,  // ✅ No debe fallar si el usuario está autenticado
        cupon_id: cupon.id,
        total_amount: parseFloat(cupon.precio) + 5.00,
        email: "cliente@email.com",  
        first_name: "Juan",
        last_name: "Pérez",
        phone_number: "5555551010"
      }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Error al generar el checkout en Clover");

    // ✅ Redirigir al usuario a Clover Hosted Checkout sin bloqueos
    console.log("🔄 Redirigiendo a Clover Hosted Checkout:", data.checkout_url);
    window.location.href = data.checkout_url;

  } catch (err) {
    setError(err.message);
    console.error("🚨 Error en el pago:", err.message);
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <Button onClick={() => setShowModal(true)} className="w-full text-lg font-bold bg-green-500 text-white hover:bg-green-600">
        Comprar con Clover
      </Button>
      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <Modal.Header>Confirmar Compra</Modal.Header>
        <Modal.Body>
          <p className="text-xl font-bold">Total a pagar en Clover: <span className="text-green-600">${cupon.precio + 5.00}</span></p>
          <p className="text-gray-500">Incluye un fee de servicio de $5.00.</p>
          {error && <p className="text-red-500">{error}</p>}
        </Modal.Body>
        <Modal.Footer>
          {loading ? <Spinner size="lg" /> : (
            <Button color="success" onClick={handleCheckout} className="w-full text-lg font-bold">
              Ir a Clover
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CloverPayment;
